module.exports = __webpack_public_path__ + "img/thumbs_up_emoji.bc75052.png";